// extracted by mini-css-extract-plugin
export var measureBox = "_cj-0";